import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

try {
  if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  } else if (pdfFonts && pdfFonts.vfs) {
    pdfMake.vfs = pdfFonts.vfs;
  } else if (typeof window !== 'undefined' && window.pdfMake && window.pdfMake.vfs) {
    pdfMake.vfs = window.pdfMake.vfs;
  }
} catch (err) {
  console.warn('PDFMake VFS initialization fallback triggered:', err);
}

export const pdfEngine = pdfMake;
export default pdfMake;
